import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <div className="absolute inset-0 bg-grain opacity-30 pointer-events-none" />
      <div className="relative z-10">
        <h1 className="font-display text-9xl md:text-[12rem] font-medium text-foreground-200 select-none pointer-events-none mb-4">
          404
        </h1>
        <h2 className="font-body text-xl md:text-2xl font-semibold text-foreground-50 mt-6">
          Page Not Found
        </h2>
        <p className="font-body text-sm text-foreground-600 mt-2 mb-8">
          {location.pathname}
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-body text-sm font-medium rounded-lg transition-all duration-500 ease-silk whitespace-nowrap"
        >
          <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center" />
          <span>Back to Home</span>
        </Link>
      </div>
    </div>
  );
}